import { render, staticRenderFns } from "./addStudentDrawer.vue?vue&type=template&id=72f880ca"
import script from "./addStudentDrawer.vue?vue&type=script&lang=js"
export * from "./addStudentDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports